import { cn } from "@/lib/utils";

// Optically matched to MenuIcon rather than boxed to match it: same 12px box,
// same 1.5 stroke and round caps, ink spanning 10 of the 12 units. A lucide X
// only inks the middle half of its viewBox, so dropped into this button it
// reads far lighter than the three bars it replaces.
const CloseIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    aria-hidden
    className={cn("h-s w-s", className)}
  >
    <path
      d="M1 1l10 10M11 1L1 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default CloseIcon;
